import type { PlainDateString } from "@sa-nu/shared-utils/date";

type CheckOutItem = {
  date: PlainDateString;
  available: boolean;
};

type CheckoutWindow = {
  /** チェックアウト候補の数 = 最大泊数 */
  maxNights: number;
  /** 選択不可なチェックアウト日 (available === false) */
  coDisabledDates: Set<PlainDateString>;
};

/**
 * accommodationReservationCheckOutAvailabilities の items を
 * DatePicker で使いやすい形に変換する。
 *
 * off-by-one は backend 解決済みのため、FE は素直に available === false を disabled にマップするだけ。
 */
export function deriveCheckoutWindow(items: CheckOutItem[]): CheckoutWindow {
  const coDisabledDates = new Set(
    items.filter((item) => !item.available).map((item) => item.date),
  );
  return {
    maxNights: items.length,
    coDisabledDates,
  };
}
